const footerLinks = [
  {
    title: '影视分类',
    links: ['动作电影', '科幻电影', '悬疑推理', '古装剧集', '都市情感'],
  },
  {
    title: '热门推荐',
    links: ['新片推荐', '热门榜单', '精选专题', '高分纪录片', '动画动漫'],
  },
  {
    title: '关于平台',
    links: ['关于我们', '常见问题', '最新动态', '联系我们', '移动观影'],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 no-underline">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </span>
              <span className="text-lg font-bold text-white whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                酷客影院
              </span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              酷客影院提供海量高清电影和高清电视剧，支持超清播放，画质清晰不缓冲，满足追求极致观影体验的用户。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-all cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-all cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-all cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col, i) => (
            <div key={i}>
              <h4 className="text-sm font-semibold text-white mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href="#hero"
                      className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-foreground-800">
          <div className="mb-6">
            <h4 className="text-xs font-medium text-foreground-500 mb-3 uppercase tracking-wider">合作伙伴</h4>
            <p className="text-xs text-foreground-600">诚邀优质影视内容方与品牌伙伴加入合作</p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 酷客影院. 本站内容仅供学习交流使用.
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <a href="#faq" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
              <a href="#faq" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#faq" className="text-xs text-foreground-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}